interface IProps {
  className?: string;
}

const ModalHeaderIcon = ({ className }: IProps) => {
  return (
    <svg
      className={className}
      width='92'
      height='76'
      viewBox='0 0 92 76'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M45.8112 62.3372C63.2252 62.3372 77.3198 48.3729 77.3198 31.1435C77.3198 13.9141 63.2252 0 45.8112 0C28.4484 0 14.3027 13.9643 14.3027 31.1937C14.3027 48.4231 28.4484 62.3372 45.8112 62.3372Z'
        fill='#CAD4D0'
      />
      <path
        d='M60.8732 62.2215C56.0728 62.3722 50.3022 62.2215 46.2169 62.1713C42.1825 62.322 36.3609 62.3722 31.5605 62.2215C36.3098 59.5592 37.995 54.5863 38.1993 51.3213H54.1323C54.4898 54.5361 56.175 59.5592 60.8732 62.2215Z'
        fill='#E6F5EE'
      />
      <g filter='url(#filter0_d_5121_14192)'>
        <path
          d='M76.2962 9.72923V50.7683C76.2962 51.8232 75.4791 52.5767 74.5599 52.5767H18.1816C17.2113 52.5767 16.4453 51.773 16.4453 50.7683V9.72923C16.4453 8.77483 17.2624 7.9209 18.1816 7.9209H74.4577C75.5302 7.97113 76.2962 8.77483 76.2962 9.72923Z'
          fill='white'
        />
      </g>
      <path
        d='M76.1601 9.48742V45.6497H16.3105V9.48742C16.3105 8.50246 17.1486 7.6582 18.0564 7.6582H74.3444C75.3919 7.6582 76.1601 8.50246 76.1601 9.48742Z'
        fill='#B7C3C5'
      />
      <path d='M74.0107 10.2607H18.3945V43.5683H74.0806V10.2607H74.0107Z' fill='white' />
      <rect x='20.7676' y='12.6768' width='17.2448' height='12.9412' fill='#C9D3D0' />
      <rect x='42.1152' y='12.6768' width='28.7414' height='5.25735' fill='#C9D3D0' />
      <rect x='42.1152' y='28.4492' width='28.7414' height='5.25735' fill='#C9D3D0' />
      <rect x='42.1152' y='19.9561' width='28.7414' height='2.42647' fill='#C9D3D0' />
      <rect x='42.1152' y='35.7285' width='28.7414' height='2.42647' fill='#C9D3D0' />
      <rect x='20.7676' y='28.4482' width='17.2448' height='12.9412' fill='#C9D3D0' />
      <path
        d='M46.2681 50.1156C47.0851 50.1156 47.749 49.5128 47.749 48.6589C47.749 47.8552 47.1362 47.2021 46.2681 47.2021C45.451 47.2021 44.7871 47.8049 44.7871 48.6589C44.7871 49.4626 45.3999 50.1156 46.2681 50.1156Z'
        fill='#B7C3C5'
      />
      <path
        d='M10.5234 27.4266C11.698 27.4266 12.6172 26.5224 12.6172 25.3671C12.6172 24.2118 11.698 23.3076 10.5234 23.3076C9.3489 23.3076 8.42969 24.2118 8.42969 25.3671C8.42969 26.5224 9.39997 27.4266 10.5234 27.4266Z'
        fill='#C9D3CF'
      />
      <path
        d='M8.42988 20.7456C9.19589 20.7456 9.85977 20.0926 9.85977 19.3391C9.85977 18.5856 9.19589 17.9326 8.42988 17.9326C7.66387 17.9326 7 18.5856 7 19.3391C7 20.1428 7.66387 20.7456 8.42988 20.7456Z'
        fill='#C9D3CF'
      />
      <path
        d='M83.345 32.6001C84.8259 32.6001 86.0005 31.4447 86.0005 29.988C86.0005 28.5313 84.8259 27.376 83.345 27.376C81.864 27.376 80.6895 28.5313 80.6895 29.988C80.6895 31.4447 81.864 32.6001 83.345 32.6001Z'
        fill='#C9D3CF'
      />
      <path
        d='M55.1698 29.9625C54.9621 30.8451 54.6506 31.7796 54.2872 32.5584C53.3007 34.4794 51.7432 35.985 49.8222 36.9715C47.8493 37.9579 45.5129 38.3733 43.1766 37.8541C37.6732 36.7119 34.1427 31.3124 35.2849 25.809C36.4271 20.3056 41.7748 16.7232 47.2782 17.9173C49.2511 18.3327 50.9644 19.3191 52.4181 20.669C54.8583 23.1092 55.8967 26.6397 55.1698 29.9625Z'
        fill='#1B4332'
      />
      <path
        d='M48.4709 27.0031H46.1346V24.6668C46.1346 24.1995 45.7712 23.7842 45.252 23.7842C44.7847 23.7842 44.3694 24.1476 44.3694 24.6668V27.0031H42.033C41.5657 27.0031 41.1504 27.3666 41.1504 27.8858C41.1504 28.4049 41.5138 28.7684 42.033 28.7684H44.3694V31.1047C44.3694 31.572 44.7328 31.9873 45.252 31.9873C45.7192 31.9873 46.1346 31.6239 46.1346 31.1047V28.7684H48.4709C48.9382 28.7684 49.3536 28.4049 49.3536 27.8858C49.3536 27.3666 48.9382 27.0031 48.4709 27.0031Z'
        fill='white'
      />
      <defs>
        <filter
          id='filter0_d_5121_14192'
          x='0.909382'
          y='0.152933'
          width='90.9234'
          height='75.7281'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='7.76797' />
          <feGaussianBlur stdDeviation='7.76797' />
          <feColorMatrix type='matrix' values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_5121_14192' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_5121_14192' result='shape' />
        </filter>
      </defs>
    </svg>
  );
};

export default ModalHeaderIcon;
